import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthenticationService } from 'src/app/_services';
import { ApiService } from 'src/app/api.service';
import { TabService } from 'src/app/utils/TabService';
import { first } from 'rxjs/operators';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss'],
  providers: [MessageService, ConfirmationService, TabService]
})
export class RecoverPasswordComponent implements OnInit {

  // RECOVER FORM
  recoverPasswordFrom: FormGroup;
  security: SecurityDocument;
  currentUser: any;
  selLang: string;

  // LANGUAGE
  lbl_recover_password: string = "recover_password_";
  lbl_email: string = "email_";
  lbl_certificate: string = "certificate_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_guide_id: string = "guideId_";
  lbl_request: string = "request_";
  lbl_go_Back: string = "back_";

  device: string;


  /**
   * The constructor initializes various services and authenticates the user using a specific method.
   * @param {FormBuilder} formBuilder - A service provided by Angular that helps in building and managing
   * forms in a reactive way.
   * @param {MessageService} messageService - A service that provides methods for displaying messages to
   * the user, such as success messages, error messages, and warning messages.
   * @param {ConfirmationService} confirmationService - A service provided by PrimeNG that allows for
   * displaying confirmation dialogs to the user.
   * @param {ApiService} apiService - An instance of the ApiService class, which is likely used to make
   * HTTP requests to an API.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to extract information about the current activated route. It provides access to the
   * route's parameters, data, and query parameters. It is typically used in Angular applications to
   * retrieve information about the current route and to navigate
   * @param {AuthenticationService} authenticationService - An instance of the AuthenticationService
   * class, which is likely used for handling user authentication and authorization.
   */
  constructor(private formBuilder: FormBuilder, private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router) {

    this.route.queryParams.subscribe(
      params => {
        this.device = params.device;
      });
    if (this.device) {
      if (this.device) {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
    }

  }

  /**
   * The function initializes form declarations and retrieves security information.
   */
  ngOnInit(): void {

    // LANG
    this.route.queryParams
      .subscribe(
        params => {

          this.selLang = params.language;
        });

    // FORMS DECLARATIONS 
    this.recoverPasswordFrom = this.formBuilder.group({
      "currentEmail": new FormControl("", [
        Validators.required,
        Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$"),
        Validators.maxLength(100),
        Validators.minLength(2),
      ]),
      "currentCertified": new FormControl("", [
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(10),
        Validators.minLength(2),
      ]),
      "currentIdGuide": new FormControl("", [
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(7),
        Validators.minLength(2),
      ]),
    });
  }




  /**
   * The function confirms whether the recover password form is valid and processes it if it is,
   * otherwise it validates all form fields.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. It could be a button click, form submission, or any other user interaction that calls the
   * function. The function uses the event parameter to prevent the default behavior of the event if the
   * form is not valid, and to proceed with
   */
  confirmRecoverPassword(event) {
    this.recoverPasswordFrom.markAsUntouched();

    event.preventDefault();
    this.validateAllFormFields(this.recoverPasswordFrom);

    // VALIDO PROCESA
    let body = {
      email: this.recoverPasswordFrom.controls["currentEmail"].value,
      certif: this.recoverPasswordFrom.controls["currentCertified"].value,
      guideId: this.recoverPasswordFrom.controls["currentIdGuide"].value,
      language: this.selLang
    }
    this.apiService.passwordRecover(body).then(
      data => {
        if (data != null && data.status == 'OK') {
          this.resetForms();
          if (data.errorMessage) {
            this.messageService.add({ key: 'tst', severity: 'success', summary: data.errorMessage, detail: ' ', life: 10000 });
          } else {
            this.messageService.add({ key: 'tst', severity: 'success', summary: 'Recuperar contraseña', detail: "Pronto le llegará correo con su contraseña", life: 7000 });
          }
        } else {
          this.messageService.add({ key: 'tst', severity: 'error', summary: data.errorMessage, detail: ' ', life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Recupera Contraseña', detail: error, life: 3000 });
      });



  }
  /**
 * The function resets a user form by calling the reset method on a validation object.
 */
  resetForms() {
    this.recoverPasswordFrom.reset();
  }

  /**
   * This function recursively marks all form controls in a FormGroup as touched.
   * @param {FormGroup} formGroup - A FormGroup object that represents a group of FormControls. It is
   * used to manage the validation and submission of a group of related form controls.
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  /**
   * This function authenticates a user by calling a login function and subscribing to the response.
   * @param {string} user - a string representing the username of the user trying to authenticate.
   * @param {string} password - A string representing the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.currentUser = this.authenticationService.currentUserValue;
            this.getSecurity();
          }
        },
        error => {
          console.error(error);
        });
  }

  /**
   * The function retrieves security information for the current user and sets the language and
   * translated labels accordingly.
   */
  getSecurity() {
    this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
      data => {
        this.security = data;

        if (this.security) {

          this.getTranslatedLabels();

        }
      });
  }

  /**
   * This function retrieves translated labels from an API and updates the corresponding variables with
   * the translated values.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.selLang != null ? this.selLang : window.navigator.language.split("-")[0],
      'region': this.security.region,
      'lstLabels': [this.lbl_recover_password, this.lbl_email, this.lbl_certificate, this.lbl_cell_phone, this.lbl_guide_id, this.lbl_request, this.lbl_go_Back]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_recover_password = map.get(this.lbl_recover_password);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_request = map.get(this.lbl_request);
        this.lbl_go_Back = map.get(this.lbl_go_Back);
      });
  }

  /**
   * The function "goBack" closes the current window.
   */
  goBack() {
    window.close();
  }
}

